import API from '@/services/API.js';
import _indexOf from 'lodash/indexOf'
import _findIndex from 'lodash/findIndex'
import _reduce from 'lodash/reduce'
import moment from 'moment';
import 'moment-timezone';

var PNF = require('google-libphonenumber').PhoneNumberFormat;
var phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
var sha1 = require('sha1');


export default {
    sanitize(str, strong) {
        if (!str) {
            return '';
        }
        if (strong == null) {
            strong = false;
        }
        var sanitizedStr = str;
        sanitizedStr = sanitizedStr.toLowerCase();
        sanitizedStr = sanitizedStr.replace(/[àâä]/g, "a");
        sanitizedStr = sanitizedStr.replace(/[èéêë]/g, "e");
        sanitizedStr = sanitizedStr.replace(/[îï]/g, "i");
        sanitizedStr = sanitizedStr.replace(/[ôö]/g, "o");
        sanitizedStr = sanitizedStr.replace(/[ùûü]/g, "u");
        sanitizedStr = sanitizedStr.replace(/[ÿ]/g, "y");
        if (strong === true) {
            sanitizedStr = sanitizedStr.replace(/'/g, "-");
            sanitizedStr = sanitizedStr.replace(/ /g, "-");
            sanitizedStr = sanitizedStr.replace(/°/g, "");
        }
        return sanitizedStr;
    },
    strip(html) {
        let doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
    },
    capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    },
    alertNumberFormated(alertId) {
        let temp = this.pad(alertId.toString(), '0', 9)
        let temp2 = []
        for (var i = 0; i < temp.length; i += 3) {
            temp2.push(temp.substr(i, 3))
        }
        return temp2.join('-')
    },
    addIndexGeojson(arr) {
        var indexedArr = []
        arr.forEach(function (obj, idx) {
            obj.properties.index = idx;
            obj.properties.lng = obj.geometry.coordinates[0];
            obj.properties.lat = obj.geometry.coordinates[1];
            indexedArr.push(obj);
        });
        return indexedArr;
    },
    phoneCleaner(phone) {
        var phoneT = phone;
        if (phoneT.substr(0, 1) == '+') {
            phoneT = phoneUtil.parse(phone, '');
        } else {
            phoneT = phoneUtil.parse(phone, 'FR');
        }

        return phoneUtil.format(phoneT, PNF.E164);
    },
    isValidPhoneNumber(phone) {
        var phoneT = phone;
        try {
            if (phoneT.substr(0, 1) == '+') {
                phoneT = phoneUtil.parse(phone, '');
            } else {
                phoneT = phoneUtil.parse(phone, 'FR');
            }
        } catch (exception) {
            return false;
        }
        if (phoneUtil.isValidNumber(phoneT)) {
            return true;
        }
        return false;
    },
    phoneTransformer(phone) {
        var phoneT = phone;
        if (phoneT.substr(0, 1) == '+') {
            phoneT = phoneUtil.parse(phone, '');
        } else {
            phoneT = phoneUtil.parse(phone, 'FR');
        }

        return phoneUtil.format(phoneT, PNF.E164);
    },
    isValidEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    },
    phonePicture(manufacturer, model) {
        var hash = '0';
        if (manufacturer != null && model != null) {
            hash = sha1(manufacturer.toLowerCase() + model.toLowerCase().replace(new RegExp(' ', 'g'), ''));
        }
        return API.route(API.endpoints.datis.picture, {hash: hash});
    },
    pad(str, char, nbChars) {
        var out = '';
        var len = str.toString().length;
        for (var i = 0; i < nbChars - len; i++) {
            out += char;
        }
        out += str;
        return out;
    },
    formatLicenceId(licenceId) {
        const LICENCE_LENGTH = 8;
        return `#${licenceId.toString().padStart(LICENCE_LENGTH, '0')}`;
    },
    geojson2tree(geojson) {
        var tree = [],
            zones = geojson.zones.features,
            aps = geojson.actionpoints.features;

        //Parse des zones
        var tempZone;
        var newTempZone = {};
        for (var zoneIndex in zones) {
            tempZone = zones[zoneIndex].properties;
            newTempZone = {};
            newTempZone.id = tempZone.id;
            newTempZone.label = tempZone.label;
            newTempZone.type = tempZone.type;
            newTempZone.icon = tempZone.icon;
            newTempZone.children = [];
            tree.push(newTempZone);
        }
        //Parse des AP
        var tempAP;
        var newTempAP = {};
        for (var APIndex in aps) {
            tempAP = aps[APIndex].properties;

            newTempAP = {};
            newTempAP.id = tempAP.id;
            newTempAP.label = tempAP.label;
            newTempAP.type = tempAP.type;
            newTempAP.icon = tempAP.icon;

            if (tempAP.parentId != null) {
                for (var tIndex in tree) {
                    var temp = tree[tIndex];
                    if (temp.type == 'zone' && temp.id == tempAP.parentId) {
                        temp.children.push(newTempAP);
                    }
                }
            } else {
                tree.push(newTempAP);
            }
        }
        return tree;
    },
    getIndexByIdInArray: function (arr, id) {
        var result = false;
        for (var i in arr) {
            if (arr[i].id == id) {
                return i;
            }
        }
        return result;
    },
    getByIdInTree: function (arr, id) {

        return this._r(arr, id);

    },
    getBuildingParent: function (arr, item) {
        var path = item.pathOrder.split('.');
        var node = null;
        for (var i = 1; i < path.length; i++) {
            node = this.getByIdInTree(arr, path[i]);
            if (node.type == 4) {
                return node;
            }
        }
    },
    _r: function (arr, id) {
        var result = false;
        for (var i in arr) {
            if (arr[i].id == id) {
                return arr[i];
            }
            if (arr[i].children && arr[i].children.length > 0) {
                result = this._r(arr[i].children, id);
                if (result !== false) {
                    return result;
                }
            }
        }
        return result;
    },
    t(key, params) {
        return window.V.$i18n.t(key, params)
    },
    tc(key, val, obj) {
        return window.V.$i18n.tc(key, val, obj)
    },
    te(key, params) {
        return window.V.$i18n.te(key, params)
    },
    dataURLtoFile(dataurl, filename) {
        if (dataurl != null) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, {type: mime});
        }
    },

    isAPable(nodeType) {
        if (nodeType == 2 || nodeType == 3 || nodeType == 4 || nodeType == 7) {
            return true;
        }
        return false;
    },

    compareHash: function (config, originalHash) {
        var newHash = this.getProfileHash(config);

    },

    getProfileHash: function (config) {

        var profileConfForHash = this.getFlatConfig(config);

        profileConfForHash = this.sortObject(profileConfForHash);

        var signature = '';

        for (var piKeyFinal in profileConfForHash) {
            if (profileConfForHash[piKeyFinal] == null) {
                signature += piKeyFinal;
            } else {
                signature += piKeyFinal + profileConfForHash[piKeyFinal];
            }

        }

        signature = sha1(signature);

        return signature;

    },

    getFlatConfig: function (config) {
        var profileFlatConfig = {};

        for (var piKey in config) {
            var profileItem = config[piKey];

            if (profileItem.type == null) {
                //Si on est dans le cas d'une syntaxe pointée
                for (var piKey2 in profileItem) {
                    if (piKey2 != 'description') {
                        var profileItemL2 = profileItem[piKey2];
                        if (piKey2 == 'alert') {
                            //Cas spécifique des alertes
                            for (var piKey3 in profileItemL2) {
                                profileFlatConfig[piKey + '.' + piKey2 + '.' + piKey3] = profileItemL2[piKey3].value;
                            }

                        } else {
                            //Cas standard
                            profileFlatConfig[piKey + '.' + piKey2] = profileItemL2.value;
                        }

                    }

                }

            } else {
                //Si on est dans le cas d'une syntaxe simple
                if (profileItem.type == 'array') {

                    if (profileItem.value != null && profileItem.value.length > 0) {
                        profileFlatConfig[piKey] = '';
                        for (var i = 0; i < profileItem.value.length; i++) {
                            profileFlatConfig[piKey] += profileItem.value[i].key;

                            if (i < (profileItem.value.length - 1)) {
                                profileFlatConfig[piKey] += ',';
                            }
                        }


                    } else {
                        profileFlatConfig[piKey] = '';
                    }

                } else {
                    profileFlatConfig[piKey] = profileItem.value;
                }

            }
        }


        return profileFlatConfig;
    },

    sortObject: function (o) {
        var sorted = {},
            key, a = [];

        for (key in o) {
            if (o.hasOwnProperty(key)) {
                a.push(key);
            }
        }

        a.sort();

        for (key = 0; key < a.length; key++) {
            sorted[a[key]] = o[a[key]];
        }
        return sorted;
    },

    compareDefs: function (newDef, oldDef) {
        const convertValuesToString = function (obj) {
            let objToString = JSON.stringify(obj)
            //This ReGex transforms any value in an object into a string
            return objToString.replace(/:([^"[{][0-9A-Za-z]*)([,\]\}]?)/g, ':\"$1\"$2')
        }

        var hasModifications = {
            meta: false,
            datis: false,
            config: false,
            alerts: false
        };

        if (convertValuesToString(newDef.meta) !== convertValuesToString(oldDef.meta)) {
            hasModifications.meta = true;
        }

        if (convertValuesToString(newDef.datis) !== convertValuesToString(oldDef.datis)) {

            hasModifications.datis = false;
            for (let dati in newDef.datis) {
                if (newDef.datis[dati].hasOwnProperty('children')) {
                    for (let child in newDef.datis[dati].children) {
                        if (newDef.datis[dati].children[child].selected !== oldDef.datis[dati].children[child].selected) {
                            hasModifications.datis = true;
                        }
                    }
                } else if (newDef.datis[dati].selected !== oldDef.datis[dati].selected) {
                    hasModifications.datis = true;
                }
            }
        }
        if (convertValuesToString(newDef.config) !== convertValuesToString(oldDef.config)) {
            hasModifications.config = true;
        }
        if (convertValuesToString(newDef.alerts) !== convertValuesToString(oldDef.alerts)) {
            hasModifications.alerts = true;
        }
        return hasModifications;
    },

    checkForExistingProfile: function (profile, profiles) {
        var hash = this.getProfileHash(profile.config);


        for (var profileKey in profiles) {
            var profileItem = profiles[profileKey];
            if (profileItem.meta.hash == hash) {
                return profileItem;
            }
        }

        return false;
    },

    intersectwith: function (f, xs, ys) {
        return xs.filter(function (x) {
            return ys.some(function (y) {
                return f(x, y);
            });
        });
    },

    equals: function (x, y) {
        return x === y;
    },

    notEquals: function (x, y) {
        return x !== y;
    },

    compareNombres: function (a, b) {
        return a - b;
    },

    getMimeFromOutput: function (output) {
        switch (output) {
            case 'html':
                return 'text/html';
                break;
            case 'pdf':
                return 'application/pdf';
                break;
            case 'xls':
                return 'application/vnd.ms-excel';
                break;
        }
    },

    getOrdinal(number, lang) {
        if (lang == null)
            lang = 'fr';

        switch (lang) {
            case 'fr':
                return number + (number === 1 ? 'er' : 'ème');
                break;
            case 'en':
                var s = ["th", "st", "nd", "rd"],
                    v = number % 100;
                return number + (s[(v - 20) % 10] || s[v] || s[0]);
                break;
        }
        return number;
    },

    getFlatACL(aclCollection) {
        //return aclCollection;
        let permissions = this.getFlatPermissions(aclCollection.permissions)
        let roles = this.getFlatRoles(aclCollection.roles)


        return {
            permissions: permissions,
            roles: roles,
            options: this.getFlatOptions(aclCollection.options)
        }
    },
    getFlatOptions(optionsCollection) {
        return optionsCollection.reduce((acc, cur) => {
            acc[cur.idoption] = cur.lib_option
            return acc
        }, [])
    },

    getFlatPermissions(permissionsCollection) {
        let permissions = [];
        for (let permKey in permissionsCollection) {
            permissions.push(permissionsCollection[permKey].name);
        }

        return permissions;
    },
    getFlatRoles(rolesCollection) {
        let roles = [];
        for (let roleKey in rolesCollection) {
            roles.push(rolesCollection[roleKey].name);
        }

        return roles;
    },

    can(permission) {
        return _indexOf(window.V.acl.permissions, permission) !== -1;
    },

    reportResourceSpliceKey(resources, key) {
        let index = _findIndex(resources.type, o => {
            return o == key
        })
        if (index != -1) {
            resources.q.splice(index, 1);
            resources.type.splice(index, 1);
        }
        return resources;
    },
    getCentroid(coord) {
        var center = _reduce(coord, function (x, y) {
            return [x[0] + y[0] / coord.length, x[1] + y[1] / coord.length]
        }, [0, 0])
        return center;
    },
    readableDuration(seconds) {
        var readable = this.t('global.in') + ' '

        if (seconds < 0) {
            readable = this.t('global.since1') + ' '
            seconds = Math.abs(seconds)
        }

        var numhours = Math.floor(((seconds % 31536000) % 86400) / 3600);
        var numminutes = Math.floor((((seconds % 31536000) % 86400) % 3600) / 60);
        var numseconds = (((seconds % 31536000) % 86400) % 3600) % 60;

        if (numseconds > 0 && numminutes < 59) {
            numminutes++
            if (numminutes > 59) {
                numminutes = 59
                numhours++
            }
        }
        if (numhours > 0) {
            readable += numhours + "h " + this.t('global.since2')
        }
        return readable + numminutes + "min ";
    },
    //THEME SFR
    isThemeSfr() {
        return window.location.host.includes('sfr')
    },
    isThemeCatsafe() {
        return window.location.host.includes('catsafe')
    },
    isThemeBeepiz() {
        return !this.isThemeSfr() && !this.isThemeCatsafe()
    },
    getThemeName() {
        if (this.isThemeSfr()) return 'sfr'
        if (this.isThemeCatsafe()) return 'catsafe'
        return 'default'
    },
    getApplicationName() {
        if (this.isThemeSfr()) return 'SFR DATI'
        if (this.isThemeCatsafe()) return 'CAT\'SAFE'
        return 'Beepiz'
    },
    getApplicationNameNormalized() {
        if (this.isThemeSfr()) return 'SFRDATI'
        if (this.isThemeCatsafe()) return 'CATSAFE'
        return 'Beepiz'
    },
    getDevantBaseUrl() {
        if (this.isThemeSfr()) return process.env.BEEPIZ_DEVANT_BASE_URL_SFR
        if (this.isThemeCatsafe()) return process.env.BEEPIZ_DEVANT_BASE_URL_CATSAFE
        return process.env.BEEPIZ_DEVANT_BASE_URL
    },
    setTheme() {
        let theme = this.getThemeName();
        document.getElementsByTagName('body')[0].classList.add(theme)
    },
    checkBills() {
        if (window.V) {
            if (window.V.clientInfos) {
                if (window.V.clientInfos.isBlocked == 1) {
                    // 'Votre compte présente une ou plusieurs irrégularités. Afin d\'éviter une coupure de service, veuillez vous rapprocher rapidement du service administratif (+33247411010)'
                    window.Vfc.$refs.messages.sendMessage('error', this.t('global.isBlocked1'));
                } else if (window.V.clientInfos.isBlocked == 2) {
                    window.Vfc.showBlocker(true)
                }
            }
        }
    },
    momentLocalised(eventDate) {
        const defaultTz = "Europe/Paris";
        if (typeof eventDate === 'object' && eventDate.date !== undefined) {
            if (eventDate.timezone !== undefined) {
                return moment.tz(eventDate.date, eventDate.timezone).local();
            }
            return moment.tz(eventDate.date, defaultTz).local();
        }
        return moment.tz(eventDate, defaultTz).local();
    },
    getIconAccessory(iconName) {
        switch (iconName) {
            case "beepiz-catsafe-icat01":
                return this.getAccessoryInformation("icat_01").logo
            case "beepiz-xcommand":
                return this.getAccessoryInformation("x_command").logo

            case "icon-watch-connect":
            case "icon-watch-disconnect":
            case "icon-watch-test":
            case "beepiz-sos-button":
                return this.getAccessoryInformation("sos_button").logo

            default:
                return null
        }
    },
    getAccessoryInformation(accessoryKey) {
        switch (accessoryKey) {
            case "icat_01":
                return {
                    logo: require("@/assets/img/iconIcat.svg"),
                    label: window.V.$i18n.t("home.widgets.list.icat01"),
                    subComponents: "Icat01"
                }
            case'sos_button':
                return {
                    logo: require("@/assets/img/IconSosButton.svg"),
                    label: window.V.$i18n.t("home.widgets.list.sosButton")
                }
            case'x_command':
                return {
                    logo: require("@/assets/img/iconXCommand.svg"),
                    label: window.V.$i18n.t("home.widgets.list.xCommand")
                }
        }
    },
}
